import axios from 'axios'

const guest_register_form = {
  namespaced: true,
  state() {
    return {
      data: {
        name: null,
        name_kana: null,
        email: null,
        uuid: null,
        password: null,
        licence_type: null,
        licence_number: null,
        postal_code: null,
        prefecture_code: null,
        address1: null,
        address2: null,
        tel: null,
        fax: null,
        contact: null,
        company_name: null,
        company_name_kana: null,
        office: null,
        department: null,
        management_company_code: null,
      },
      errors: {},
    }
  },

  getters: {
    parameters(state) {
      return state.data;
    },
  },

  mutations: {
    setErrors(state, errors) {
      state.errors = { ...errors }
    },
    resetData(state) {
      state.data.name = null;
      state.data.name_kana = null;
      state.data.email = null;
      state.data.uuid = null;
      state.data.password = null;
      state.data.licence_type = null;
      state.data.licence_number = null;
      state.data.postal_code = null;
      state.data.prefecture_code = null;
      state.data.address1 = null;
      state.data.address2 = null;
      state.data.tel = null;
      state.data.fax = null;
      state.data.contact = null;
      state.data.company_name = null;
      state.data.company_name_kana = null;
      state.data.office = null;
      state.data.department = null;
      state.data.management_company_code = null;
    },
    setManagementCompanyCode(state, data) {
      state.data.management_company_code = data;
    },
    clearError(state) {
      state.errors = {}
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    register({ getters, commit }, payload) {
      commit('clearError')
      return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(() => {
          axios.post(`/api/guests/${payload.guestType}`, getters.parameters).then(() => {
            commit('setFlashMessage', { value: '登録しました' }, { root: true });
            commit('resetData')
            commit('clearError')
            resolve(true)
          }).catch((error) => {
            let handled = false;
            if (error.response.status === 422) {
              commit('setErrors', error.response.data.errors);
              handled = true;
            }
            reject({ handled });
          });
        }).catch(() => reject());
      });
    }
  }
}

export default guest_register_form;
